import React, { createContext, useContext } from "react"

import { useAddNewLeadList } from "../../../hooks/leadListAddNewListHooks"

const LeadListContext = createContext(null)

export const LeadListAddNewContextProvider = ({ children }) => {
  const leadList = useAddNewLeadList()

  return <LeadListContext.Provider value={leadList}>{children}</LeadListContext.Provider>
}

// Custom hook for consuming the context easily
export const useLeadListContext = () => {
  const context = useContext(LeadListContext)
  if (!context) {
    throw new Error("useLeadListContext must be used within a LeadListProvider")
  }
  return context
}
